import { createFeatureSelector } from '@ngrx/store';
import { SERVICING_COMMON_STORE_NAME, ServicingCommonState } from './servicing-common.state';

/** Select ServicingCommon State */
export const selectServicingCommonState = createFeatureSelector<ServicingCommonState>(SERVICING_COMMON_STORE_NAME);
